import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

export default function Loading() {
    //const header = document.getElementsByTagName('header')
    const body = document.getElementsByTagName('body')
    //const heightHeader = header[0].offsetHeight
    const bodyHeight   = body[0].offsetHeight
    
    return <div style={{minWidth: '100vh'}}>
        <div style={{
            display: 'flex', 
            width: '100%',
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: '#ffffffcf', 
            //minHeight: '100vh',
            minWidth: '100wh',
            minHeight: `calc(100vh - ${bodyHeight})`,
            overflow: 'hidden', 
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            zIndex: 6
        }}>
            <CircularProgress disableShrink />
        </div>
    </div>
}